export interface CompleteDesignerContext {
    codsistema: string;
    codnegocio: string;
    codproducto: string;
    codservicio: string;
    codcomando: string;
    documentKind: string;
    flowId: string;
    pageId: string;
    listPath: string;
}

export enum SxDocumentTypes {
    PolicyDocument = 'Policy',
    CustomerDocument = 'Customer',
    ClaimDocument = 'Claim',
    UnknownDocument = 'Unknown',
    None = 'None'
}

export const DefaultLayout = {
    root: {
        type : 'SxPanel',
        id: 'mainPanel',
        title: '',
        childs: []
    }
};

export const NonTransLayout = {
    layout: {
        HasChilds: false,
        root: DefaultLayout.root,
        type: "page"
    },
}






// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/main/completeContext.ts